var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataList',{attrs:{"title":"Платники","resource":"payers","columns":_vm.columns,"get-items-fn":_vm.getPayers,"search-label":'Пошук за назвою платника'}})}
var staticRenderFns = []

export { render, staticRenderFns }